import commonUtil from '../../../../utils/commonUtil';
import cryptoUtil from '../../../../utils/cryptoUtil';

export const GET_GIFT_LIST_GUEST_VIEW = 'GET_GIFT_LIST_GUEST_VIEW';
export const GET_GIFT_LIST_GUEST_VIEW_SUCCESS = 'GET_GIFT_LIST_GUEST_VIEW_SUCCESS';
export const GET_GIFT_LIST_GUEST_VIEW_FAIL = 'GET_GIFT_LIST_GUEST_VIEW_FAIL';
export const ADD_ITEM_TO_CART = 'ADD_ITEM_TO_CART';
export const ADD_ITEM_TO_CART_SUCCESS = 'ADD_ITEM_TO_CART_SUCCESS';
export const ADD_ITEM_TO_CART_FAIL = 'ADD_ITEM_TO_CART_FAIL';
export const SET_GIFTEE_NAME = 'SET_GIFTEE_NAME';
export const ADD_ITEM_TO_EXPRESS_CART = 'ADD_ITEM_TO_EXPRESS_CART';
export const ADD_ITEM_TO_EXPRESS_CART_SUCCESS = 'ADD_ITEM_TO_EXPRESS_CART_SUCCESS';
export const ADD_ITEM_TO_EXPRESS_CART_FAIL = 'ADD_ITEM_TO_EXPRESS_CART_FAIL';

// export function isGiftListLoaded(globalState) {
//   return globalState.giftlistguestview && globalState.giftlistguestview.loaded;

// }
export function getGiftListGuestView(eventId, priceOrder, categoryId, currentPage, isShowAll, resultsPerPage) {
  const _guestViewGiftList = {};
  _guestViewGiftList.brand = commonUtil.getBrand();
  _guestViewGiftList.channel = commonUtil.getChannel();
  _guestViewGiftList.eventId = eventId;
  if (categoryId) {
    _guestViewGiftList.categoryId = categoryId;
  }
  if (priceOrder) {
    _guestViewGiftList.priceOrder = priceOrder;
  }
  _guestViewGiftList.currentPage = currentPage;
  _guestViewGiftList.isShowAll = isShowAll || 'false';
  _guestViewGiftList.resultsPerPage = resultsPerPage || '';
  return {
    types: [GET_GIFT_LIST_GUEST_VIEW, GET_GIFT_LIST_GUEST_VIEW_SUCCESS, GET_GIFT_LIST_GUEST_VIEW_FAIL],
    promise: client => client.post('/api/getGiftListGuestView', {
      data: (_guestViewGiftList),
    }),
  };
}

export function setGifteeName(gifteeName) {
  return {
    type: SET_GIFTEE_NAME,
    data: gifteeName,
  };
}

// export function additemtocart(content) {
//   return commonUtil.triggerServerRequest({ url: '/api/addItemToCart', method: 'POST', data: content });
// }

export function additemtocart(content) {
  const encryptedContent = { ...content };
  if (encryptedContent.eventInfo && encryptedContent.eventInfo.address) {
    encryptedContent.eventInfo.address = cryptoUtil.encrypt(encryptedContent.eventInfo.address);
  }

  return {
    types: [ADD_ITEM_TO_CART, ADD_ITEM_TO_CART_SUCCESS, ADD_ITEM_TO_CART_FAIL],
    promise: client => client.post('/api/addItemToCart', {
      data: encryptedContent,
    }),
  };
}

export function additemtoexpresscart(content) {
  const encryptedContent = { ...content };
  if (encryptedContent.eventInfo && encryptedContent.eventInfo.address) {
    encryptedContent.eventInfo.address = cryptoUtil.encrypt(encryptedContent.eventInfo.address);
  }

  return {
    types: [
      ADD_ITEM_TO_EXPRESS_CART,
      ADD_ITEM_TO_EXPRESS_CART_SUCCESS,
      ADD_ITEM_TO_EXPRESS_CART_FAIL
    ],
    promise: client => client.post('/api/addItemToExpressCart', {
      data: encryptedContent,
    }),
  };
}

// export function additemtoexpresscart(content) {
//   return commonUtil.triggerServerRequest({ url: '/api/addItemToExpressCart', method: 'POST', data: content });
// }

export function getConfiguration(content) {
  return commonUtil.triggerServerRequest({ url: '/api/getConfiguration', method: 'POST', data: content });
}


export function GetCookie(cName) {
  if (typeof window !== 'undefined') {
    const name = cName + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const arr = decodedCookie && decodedCookie.split(';');
    for (let i = 0; i < arr.length; i++) {
      let str = arr[i];
      while (str.charAt(0) == ' ') {
        str = str.substring(1);
      }

      if (str.indexOf(name) == 0) {
        return str.substring(name.length, str.length);
      }
    }
  }
  return '';
}
